// Kick off the application.
require([
  'app',
  'settings',
  'jquery',
  'require',
  'translation',
  'plivoUtils',
  'trumbowyg'
], function(
  App,
  Settings,
  $,
  require,
  Translation,
  PlivoUtils
) {
  'use strict';

  Translation.fetchTranslations().done(function() {
    require(['router'], function(){
      //start the application
      App.start();
      PlivoUtils.init();
      $.trumbowyg.svgPath = '/vendors/ui/icons.svg';
    });
  } ).fail(function() {
      window.location.href = Settings.serverUrl + 'server-unavailable.html';
  } );
});

define("main", function(){});

